export const CloudIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="180px"
    viewBox="0 -960 960 960"
    width="180px"
    fill="#FFF"
  >
    <path d="M260-160q-91 0-155.5-63T40-377q0-78 47-139t123-78q25-92 100-149t170-57q117 0 198.5 81.5T760-520q69 8 114.5 59.5T920-340q0 75-52.5 127.5T740-160H260Zm0-80h480q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-83-58.5-141.5T480-720q-83 0-141.5 58.5T280-520h-20q-58 0-99 41t-41 99q0 58 41 99t99 41Zm220-240Z" />
  </svg>
);

export const SunIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="180px"
    viewBox="0 -960 960 960"
    width="180px"
    fill="#EAC452"
  >
    <path d="M450-770v-150h60v150h-60Zm256 106-42-42 106-107 42 43-106 106Zm64 214v-60h150v60H770ZM450-40v-150h60v150h-60ZM253-665 148-770l42-42 106 106-43 41Zm518 517L664-254l41-41 108 104-42 43ZM40-450v-60h150v60H40Zm151 302-43-42 105-105 22 20 22 21-106 106Zm289-92q-100 0-170-70t-70-170q0-100 70-170t170-70q100 0 170 70t70 170q0 100-70 170t-170 70Zm0-60q75 0 127.5-52.5T660-480q0-75-52.5-127.5T480-660q-75 0-127.5 52.5T300-480q0 75 52.5 127.5T480-300Zm0-180Z" />
  </svg>
);

export const SnowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="180px"
    viewBox="0 -960 960 960"
    width="180px"
    fill="#FFFFFF"
  >
    <path d="M240-200q-14 0-24.5-10.5T205-235q0-14 10.5-24.5T240-270q14 0 24.5 10.5T275-235q0 14-10.5 24.5T240-200Zm480 0q-14 0-24.5-10.5T685-235q0-14 10.5-24.5T720-270q14 0 24.5 10.5T755-235q0 14-10.5 24.5T720-200ZM360-40q-14 0-24.5-10.5T325-75q0-14 10.5-24.5T360-110q14 0 24.5 10.5T395-75q0 14-10.5 24.5T360-40Zm120-160q-14 0-24.5-10.5T445-235q0-14 10.5-24.5T480-270q14 0 24.5 10.5T515-235q0 14-10.5 24.5T480-200ZM600-40q-14 0-24.5-10.5T565-75q0-14 10.5-24.5T600-110q14 0 24.5 10.5T635-75q0 14-10.5 24.5T600-40ZM290-340q-86.86 0-148.43-61.52Q80-463.04 80-549.83 80-629 136.5-691 193-753 277-759q32-56 84.5-88.5T480.42-880q90.58 0 152.08 57.5Q694-765 708-680q79 4 125.5 53.5T880-510.38Q880-440 830.42-390 780.83-340 710-340H290Zm0-60h420q46.2 0 78.1-32.5 31.9-32.5 31.9-78T788.1-588q-31.9-32-78.1-32h-60v-30q0-71-49.5-120.5T480.21-820q-51.48 0-93.84 27.5Q344-765 324-718l-8 18h-28q-62 2-105 45.39-43 43.4-43 104.47Q140-488 183.93-444T290-400Zm190-210Z" />
  </svg>
);

export const RainIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="180px"
    viewBox="0 -960 960 960"
    width="180px"
    fill="#FFFFFF"
  >
    <path d="M240-200q-14 0-24.5-10.5T205-235q0-14 10.5-24.5T240-270q14 0 24.5 10.5T275-235q0 14-10.5 24.5T240-200Zm480 0q-14 0-24.5-10.5T685-235q0-14 10.5-24.5T720-270q14 0 24.5 10.5T755-235q0 14-10.5 24.5T720-200ZM360-40q-14 0-24.5-10.5T325-75q0-14 10.5-24.5T360-110q14 0 24.5 10.5T395-75q0 14-10.5 24.5T360-40Zm120-160q-14 0-24.5-10.5T445-235q0-14 10.5-24.5T480-270q14 0 24.5 10.5T515-235q0 14-10.5 24.5T480-200ZM600-40q-14 0-24.5-10.5T565-75q0-14 10.5-24.5T600-110q14 0 24.5 10.5T635-75q0 14-10.5 24.5T600-40ZM290-340q-86.86 0-148.43-61.52Q80-463.04 80-549.83 80-629 136.5-691 193-753 277-759q32-56 84.5-88.5T480.42-880q90.58 0 152.08 57.5Q694-765 708-680q79 4 125.5 53.5T880-510.38Q880-440 830.42-390 780.83-340 710-340H290Zm0-60h420q46.2 0 78.1-32.5 31.9-32.5 31.9-78T788.1-588q-31.9-32-78.1-32h-60v-30q0-71-49.5-120.5T480.21-820q-51.48 0-93.84 27.5Q344-765 324-718l-8 18h-28q-62 2-105 45.39-43 43.4-43 104.47Q140-488 183.93-444T290-400Zm190-210Z" />
  </svg>
);

export const ThunderstormIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="180px"
    viewBox="0 -960 960 960"
    width="180px"
    fill="#FFFFFF"
  >
    <path d="m475 0 97-110-80-40 113-130h80l-97 110 80 40L555 0h-80ZM235 0l97-110-80-40 113-130h80l-97 110 80 40L315 0h-80Zm55-340q-86.86 0-148.43-61.52Q80-463.04 80-549.83 80-629 136.5-691 193-753 277-759q32-56 84.5-88.5T480.42-880q90.58 0 152.08 57.5Q694-765 708-680q79 4 125.5 53.5T880-510.38Q880-440 830.42-390 780.83-340 710-340H290Zm0-60h420q46.2 0 78.1-32.5 31.9-32.5 31.9-78T788.1-588q-31.9-32-78.1-32h-60v-30q0-71-49.5-120.5T480.21-820q-51.48 0-93.84 27.5Q344-765 324-718l-8 18h-28q-62 2-105 45.39-43 43.4-43 104.47Q140-488 183.93-444T290-400Zm190-210Z" />
  </svg>
);

export const MistIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="180px"
    viewBox="0 -960 960 960"
    width="180px"
    fill="#FFFFFF"
  >
    <path d="M160-210q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h400q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H160Zm560 0q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h80q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-80ZM160-370q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h80q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-80Zm240 0q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h400q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H400ZM160-530q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h440q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H160Zm600 0q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h40q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-40ZM160-690q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h200q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H160Zm360 0q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h280q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H520Z" />
  </svg>
);

export const ArrowBackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#FFFFFF"
  >
    <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
  </svg>
);
